// extracted by mini-css-extract-plugin
module.exports = {"player":"Player_player__1lZpo","red":"Player_red__Sf8va","blue":"Player_blue__1Kuxe"};